import { createContext, useContext } from 'react';

import useCheckTransaction from '#client/hooks/useCheckTransaction';

export const CheckTransactionContext = createContext();
CheckTransactionContext.displayName = 'CheckTransactionContext';

const useCheckTransactionContext = () => {
  const context = useContext(CheckTransactionContext);

  if (typeof context === 'undefined') {
    throw new Error(
      'useCheckTransactionContext must be used within a CheckTransactionContext.Provider'
    );
  }

  return context;
};

export function CheckTransactionProvider({ children }) {
  const value = useCheckTransaction();
  return (
    <CheckTransactionContext.Provider value={value}>{children}</CheckTransactionContext.Provider>
  );
}

export default useCheckTransactionContext;
